var moment = require('moment');
// require, not import - this file is otherwise pure CommonJS (exports.x = x);
// a top-level ES `import` here would make Babel mark the whole file as an ES
// module, which breaks how other files resolve named imports from it via
// webpack's CJS interop (exactly what happened - getHyphenYYYYMMDDHHMMSS and co.
// stopped resolving elsewhere the moment this file gained one).
var { isMobile, isTablet } = require('react-device-detect');
//let now = moment();
//console.log(moment.parseZone("2020-02-17T10:51:55.000Z").format());
//console.log(moment.parseZone("2020-02-17T10:51:55.000Z").format("DD-MM-YYYY hh:mm:ss"))
var getDDMMYYYY = function(date_string) {
    if(date_string == '' || date_string == undefined)
    {
        return '';
    }
    else{
        return moment.parseZone(date_string).format('DD/MM/YYYY');
    }
}
exports.getDDMMYYYY = getDDMMYYYY;

var getDDMMMYYYY = function(date_string) {
    if(date_string == '' || date_string == undefined)
    {
        return '';
    }
    else{
        return moment.parseZone(date_string).format('DD/MMM/YYYY');
    }
}
exports.getDDMMMYYYY = getDDMMMYYYY;


var getDDMMYYYYHHMM = function(date_string) {
    if(date_string == '' || date_string == undefined)
    {
        return '';
    }
    else{
        return moment.parseZone(date_string).format('DD/MM/YYYY hh:mm');
    }
}
exports.getDDMMYYYYHHMM = getDDMMYYYYHHMM;


var getDDMMYYYYHHMMSS = function(date_string) {
    //console.log("date_string ", date_string);
    if(date_string == '' || date_string == undefined)
    {
        return '';
    }
    else{
        return moment.parseZone(date_string).format('DD/MM/YYYY HH:mm:ss');
    }
    
}
exports.getDDMMYYYYHHMMSS = getDDMMYYYYHHMMSS;


var getYYYYMMDD = function(date_string) {
    if(date_string == '' || date_string == undefined)
    {
        return '';
    }
    else{
        return moment.parseZone(date_string).format('YYYY/MM/DD');
    }
}
exports.getYYYYMMDD = getYYYYMMDD;

var getYYYYMMDDHHMMSS = function(date_string) {
    if(date_string == '' || date_string == undefined)
    {
        return '';
    }
    else{
        return moment.parseZone(date_string).format('YYYY/MM/DD HH:mm:ss');
    }
}
exports.getYYYYMMDDHHMMSS = getYYYYMMDDHHMMSS;

var getHyphenYYYYMMDDHHMMSS = function(date_string) {
    if(date_string == '' || date_string == undefined)
    {
        return '';
    }
    else{
        return moment.parseZone(date_string).format('YYYY-MM-DD HH:mm:ss');
    }
}
exports.getHyphenYYYYMMDDHHMMSS = getHyphenYYYYMMDDHHMMSS;

var getHyphenYYYYMMDDHHMM = function(date_string) {
    if(date_string == '' || date_string == undefined)
    {
        return '';
    }
    else{
        return moment.parseZone(date_string).format('YYYY-MM-DD HH:mm');
    }
}
exports.getHyphenYYYYMMDDHHMM = getHyphenYYYYMMDDHHMM;


var getHyphenYYYYMMDD = function(date_string) {
    if(date_string == '' || date_string == undefined)
    {
        return '';
    }
    else{
        return moment.parseZone(date_string).format('YYYY-MM-DD');
    }
}
exports.getHyphenYYYYMMDD = getHyphenYYYYMMDD;

var getHyphenDDMMYYYYHHMMSS = function(date_string) {
    //console.log("date_string ", date_string);
    if(date_string == '' || date_string == undefined)
    {
        return '';
    }
    else{
        return moment.parseZone(date_string).format('DD-MM-YYYY HH:mm:ss');
    }
    
}
exports.getHyphenDDMMYYYYHHMMSS = getHyphenDDMMYYYYHHMMSS;

var getHyphenDDMMMYYYYHHMM = function(date_string) {
    //console.log("date_string ", date_string);
    if(date_string == '' || date_string == undefined)
    {
        return '';
    }
    else{
        return moment.parseZone(date_string).format('DD-MMM-YYYY HH:mm');
    }
    
}
exports.getHyphenDDMMMYYYYHHMM = getHyphenDDMMMYYYYHHMM;




var getHyphenDDMMYYYY = function(date_string) {
    if(date_string == '' || date_string == undefined)
    {
        return '';
    }
    else{
        return moment.parseZone(date_string).format('DD-MM-YYYY');
    }
}
exports.getHyphenDDMMYYYY = getHyphenDDMMYYYY;

var getHyphenDDMMMYYYY = function(date_string) {
    if(date_string == '' || date_string == undefined)
    {
        return '';
    }
    else{
        return moment.parseZone(date_string).format('DD-MMM-YYYY');
    }
}
exports.getHyphenDDMMMYYYY = getHyphenDDMMMYYYY;


var getDDMMMYYYYDefault = function(date_string) {
    //console.log("date_string ", date_string);
    //var d = date_string.split(" ")

    if(date_string == '1970-01-01' || date_string == undefined || date_string == "")
    {
        return '';
    }
    else{
        return moment.parseZone(date_string).format('DD-MMM-YYYY');
    }
    
}
exports.getDDMMMYYYYDefault = getDDMMMYYYYDefault;


// var getDDMMMYYYYHHMMDefault = function(date_string) {
//     //var d = date_string.split(" ")

//    if(date_string == '' || date_string == undefined)
//     {
//         return '';
//     }
//     else{
//         return moment.parseZone(date_string).format('DD-MMM-YYYY HH:mm');
//     }
    
// }
// exports.getHyphenDDMMMYYYYHHMM = getDDMMMYYYYHHMMDefault;

var getDDMMMYYYYHHMMDefault = function(date_string) {
    //console.log("date_string ", date_string);
    if(date_string == '' || date_string == undefined || date_string == "1970-01-01T00:00:00.000Z")
    {
        return '';
    }
    else{
        return moment.parseZone(date_string).format('DD-MMM-YYYY HH:mm');
    }
    
}
exports.getDDMMMYYYYHHMMDefault = getDDMMMYYYYHHMMDefault;

var convertSecondsToHHMM = function(seconds) {
    if(seconds == "0" || seconds == "")
    {
        return "";
    }
    else{
        seconds = Number(seconds);
        var hh = Math.floor((seconds / 3600));
        var hrr = Math.floor(seconds - (hh*3600));
        var mm = Math.floor(hrr/60)
        if(mm < 10)
        {
            var mins = "0"+mm;
        }
        else
        {
            var mins = mm;
        }

        if(hh < 10)
        {
            var hrs = "0"+hh;
        }
        else
        {
            var hrs = hh;
        }
        return hrs+":"+mins;
    }
}

exports.convertSecondsToHHMM = convertSecondsToHHMM;

// Used by the mobile Load Management flow's device gate (Loginform.js's one-time
// login redirect, MobileTruckLoadShell's live guard) to decide "should this device
// see the mobile UI" - by actual device type, not viewport width. Hand-rolled
// width/touch/UA-regex checks were all tried and dropped, each with real false
// positives/negatives against actual test devices (a touch-capable desktop window
// resized narrow, an iPad's UA masquerading as a Mac, etc.). react-device-detect
// (ua-parser-js under the hood) is the well-tested, actively-maintained way to
// answer "what device is this" properly instead of re-guessing that ourselves.
var isMobileOrTabletDevice = function() {
    return isMobile || isTablet;
}
exports.isMobileOrTabletDevice = isMobileOrTabletDevice;

// TEMPORARY, per explicit request - for now, only this one tester account should
// see the mobile Load Management module picker (/lm-mobile/landing, with both
// "Load Management" and "Truck Load Automation" as choices). Every other
// mobile/tablet Load Management user skips the picker entirely and lands straight
// in the Truck Load Automation dashboard. Used by both Loginform.js's one-time
// login redirect and app.jsx's live returning-session redirect, so they agree.
var MOBILE_LANDING_TESTER_EMAIL = 'tester@enmovil.ai';
var isMobileLandingTesterAccount = function() {
    return (localStorage.getItem('email') || '').toLowerCase() === MOBILE_LANDING_TESTER_EMAIL;
}
exports.isMobileLandingTesterAccount = isMobileLandingTesterAccount;

// Masters whose add/edit/delete/bulk-upload payload is the raw array itself
// (no separate metadata wrapper) need "who did this" attached to every row
// individually, so the backend can log it - same localStorage keys/field
// names already used everywhere else that builds a useractivities entry
// (reqParams.user_name/email/staff_id/user_department/designation/comp_code/
// user_role). Spread this into each row before posting.
var getUserIdentityFields = function() {
    return {
        user_name: localStorage.getItem('username'),
        email: localStorage.getItem('email'),
        staff_id: localStorage.getItem('staff_id'),
        user_department: localStorage.getItem('lm_department'),
        designation: localStorage.getItem('designation'),
        comp_code: localStorage.getItem('comp_code'),
        user_role: localStorage.getItem('roles'),
    };
}
exports.getUserIdentityFields = getUserIdentityFields;

// Trims, upper-cases, and collapses any run of internal whitespace to a
// single space - so "Transporter  Name" (typo'd double space), "transporter
// name", and " TRANSPORTER NAME " all normalize the same way. Shared by
// getCellValue/isSameIgnoreCase/findByFieldIgnoreCase below.
var normalizeForCompare = function(value) {
    return String(value || "").trim().toUpperCase().replace(/\s+/g, " ");
}
exports.normalizeForCompare = normalizeForCompare;

// Bulk-upload Excel/CSV headers arrive exactly as typed by whoever built the
// sheet (e.g. "Transporter Name" vs "TRANSPORTER NAME", extra/missing spaces).
// XLSX's sheet_to_json keys each row object by the literal header cell text,
// so a plain row["HUB"] lookup breaks on any case/whitespace variation.
// This scans the row's actual keys case/whitespace-insensitively instead of
// assuming an exact key match.
var getCellValue = function(row, headerName) {
    if (!row) return "";
    var target = normalizeForCompare(headerName);
    var keys = Object.keys(row);
    for (var i = 0; i < keys.length; i++) {
        if (normalizeForCompare(keys[i]) === target) {
            return row[keys[i]];
        }
    }
    return "";
}
exports.getCellValue = getCellValue;

// Same idea as getCellValue, but matches a header that merely STARTS WITH the
// given prefix - for headers like "FREIGHT RATE ( ₹ )" where the trailing
// currency symbol is fragile: re-saving the sample template's CSV from Excel
// with the plain "CSV" format (not "CSV UTF-8"), or a parser reading a CSV
// without a BOM, can mangle a multi-byte character like ₹ into mojibake -
// which breaks an exact match even on an unedited copy of the app's own
// template. Matching on the stable "FREIGHT RATE" prefix sidesteps that
// entirely without needing the uploaded header to reproduce the symbol.
var getCellValueByPrefix = function(row, headerPrefix) {
    if (!row) return "";
    var target = normalizeForCompare(headerPrefix);
    var keys = Object.keys(row);
    for (var i = 0; i < keys.length; i++) {
        if (normalizeForCompare(keys[i]).indexOf(target) === 0) {
            return row[keys[i]];
        }
    }
    return "";
}
exports.getCellValueByPrefix = getCellValueByPrefix;

// Case/whitespace-insensitive equality, for comparing an uploaded cell value
// (which may be typed in any case) against a reference/master value.
var isSameIgnoreCase = function(a, b) {
    return normalizeForCompare(a) === normalizeForCompare(b);
}
exports.isSameIgnoreCase = isSameIgnoreCase;

// Finds the canonical (correctly-cased) record from a reference list whose
// given field matches the uploaded value, trimmed and ignoring case. Storing
// this canonical value (instead of whatever case the uploader typed) keeps
// bulk-uploaded rows matching exactly against downstream edit dropdowns and
// exact-match filters that compare against the reference data's own casing.
var findByFieldIgnoreCase = function(list, field, value) {
    var target = normalizeForCompare(value);
    return (list || []).find(function(each) {
        return normalizeForCompare((each || {})[field]) === target;
    }) || null;
}
exports.findByFieldIgnoreCase = findByFieldIgnoreCase;




